import { camelToKebab } from '@/src/general/primitives/strings'
import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type {
  TGetRewardCitationsPayload,
  TPrayMutationData,
  TPrayMutationPayload,
  TRewardCitationData,
} from './prayApi.types'

export const prayApi = {
  createPrayer: ({ objectId, objectType, emailHash, ...params }: TPrayMutationPayload) =>
    fetcher.mutate<TPrayMutationData, { emailHash?: string }>(
      `/${camelToKebab(objectType)}/${objectId}/pray`,
      { emailHash },
      {
        params,
        method: 'POST',
      },
    ),
  getRewardCitations: ({ type }: TGetRewardCitationsPayload, { signal }: TSignalConfig) =>
    fetcher.query<TRewardCitationData>('/citations/auto', {
      signal,
      params: { type },
    }),
}
